import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const PopupTitle = styled.h3`
    ${FONTS.H3};
`;

export const PopupFooter = styled.div`
    margin-top: 16px;
    gap: 12px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        flex-direction: column;
    }
`;

export const Button = styled(BaseButton)`
    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;
